import { useEffect, useState } from 'react';
import { request } from 'cademy-shared-web';
import { toaster, Spinner } from 'evergreen-ui';
import { PaymentForm } from '../../components/index';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { useSelector } from 'react-redux';
import { Environment } from 'services/Environment';

const StripePaymentScreen = ({ onPaymentComplete, order }) => {
    const auth = useSelector((state) => state.auth);
    const [isLoading, setIsLoading] = useState(true);
    const [clientSecret, setClientSecret] = useState();
    const [stripeAccountId, setStripeAccountId] = useState();

    useEffect(() => {
        request
            .post('/apps/stripe/start-payment', { order_id: order._id })
            .then((result) => {
                setClientSecret(result.data.client_secret);
                setStripeAccountId(result.data.stripe_account_id);
                setIsLoading(false);
            })
            .catch((err) => {
                console.error('start-payment error', err);
                toaster.danger(err.safe);
                setIsLoading(false);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (isLoading || !clientSecret || !stripeAccountId) return <Spinner />;

    const billingInfo = {}; // ????

    const stripeKey = Environment.STRIPE_PUBLISHABLE_KEY;
    const stripePromise = loadStripe(stripeKey, {
        stripeAccount: stripeAccountId,
    });
    return (
        <div>
            <h1>Payment</h1>
            <Elements stripe={stripePromise} options={{ clientSecret }}>
                <PaymentForm
                    onPaymentComplete={onPaymentComplete}
                    auth={auth}
                    billingInfo={billingInfo}
                    startedAt={Math.round(Date.now() / 1000)} // Hack as these orders have no timeout
                />
            </Elements>
        </div>
    );
};

export default StripePaymentScreen;
